import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './pagination.component.scss';
var Pagination = /** @class */ (function (_super) {
    tslib_1.__extends(Pagination, _super);
    function Pagination(element) {
        return _super.call(this, element) || this;
    }
    Pagination.prototype.init = function () { };
    Pagination.prototype.bindEvents = function () { };
    return Pagination;
}(Base));
export { Pagination };



//////////////////
// WEBPACK FOOTER
// ./components/pagination/pagination.component.ts
// module id = 433
// module chunks = 0